import { PlayAppState } from './interfaces';

export function getRomBeingPlayed(state: PlayAppState): string | null {
    return state.play.playingRomId;
}
